<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__title">图文资讯</div>
    </div>
    <div class="page-panel__body">
      <el-form class="page-panel-search-form" :inline="true">
        <el-form-item>
          <el-select v-model="search.newsType" placeholder="请选择图文类别">
            <el-option v-for="item in commonJSON.newsType.options" v-show="item.enable" :key="item.value"
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="审核状态" v-model="search.newsStatus">
            <el-option :label="item.label" :value="item.value" v-for="item in commonJSON.newsStaus.options"
              :key="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入新闻名称" v-model="search.keywords"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="default" @click="getNewsList()" icon="el-icon-search"></el-button>
        </el-form-item>
        <el-form-item class="page-panel-search-form-right-button">
          <el-button type="primary" @click="add">发布</el-button>
        </el-form-item>
      </el-form>
      <ul class="article-list">
        <li class="article-list_item" v-for="item in list" :key="item.id">
          <div class="article-list-item__body">
            <div class="article-title">
              <a class="article-title__name" href="javascript:;" @click="editNews(item.newsId)">{{item.newsTitle}}</a>
              <div class="article-title__icons">
                <el-tag size="mini" class="article-title-icon">{{item.newsTypeName}}</el-tag>
              </div>
              <div class="article-title__icons">
                <el-tag size="mini" class="article-title-icon" v-if="item.newsStatus==2">已审核</el-tag>
              </div>
            </div>
            <div class="article-attrs">
              <span class="article-attr__item">发布日期： {{item.newsCreateTime}}</span>
            </div>
            <div class="article-content">{{item.newsText}}</div>
            <div class="article-attrs">
              <span class="article-attr__item_grey">新闻由</span>
              <span class="article-attr__item_black">{{item.newsCreateUserName}}</span>
              <span class="article-attr__item_grey">于</span>
              <span class="article-attr__item_black">{{item.newsUpdateTime}}</span>
              <span class="article-attr__item_grey">上传</span>

            </div>
            <div class="article-control">
              <a class="article-control__item" href="javascript:;" @click="setstate(item.newsId,2)"
                v-if="item.newsStatus==3">审核</a>
              <a class="article-control__item" href="javascript:;" @click="setstate(item.newsId,3)"
                v-if="item.newsStatus==2">取消审核</a>
              <a class="article-control__item" href="javascript:;" @click="editNews(item.newsId)">编辑</a>
              <a class="article-control__item" href="javascript:;" @click="deleteNews(item.newsId)">删除</a>
            </div>
          </div>
        </li>
      </ul>
      <div class="page-panel__footer">
        <el-pagination :current-page.sync='search.pageNo' :page-size='search.pageSize'
          layout='prev, pager, next, jumper' :total='total' @current-change='getNewsList'>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as newsAPI from '@/api/industryIdynamics';
const commonJSON = require('@/common/Json/index');
export default {
  data() {
    return {
      commonJSON,
      total: 2,
      search: {
        pageNo: 1,
        pageSize: 10,
        newsCategory: 0
      },
      list: []
    };
  },
  methods: {
    setstate(id, state) {
      this.$confirm('是否更改当前文章审核状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(state);

          newsAPI.setstate({ newsId: id, status: state }).then(res => {
            this.getNewsList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    add() {
      this.$router.push({ path: '/admin/industryIdynamics/add' });
    },
    editNews(id) {
      this.$router.push({ path: `/admin/industryIdynamics/edit/${id}` });
    },
    getNewsList() {
      newsAPI.list(this.search).then(res => {
        this.total = res.totalCount;
        this.list = res.list;
      });
    },
    deleteNews(id) {
      this.$confirm('是否删除该条新闻', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          newsAPI.deleteNews({ newsId: id }).then(res => {
            this.getNewsList();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  },
  created() {
    this.getNewsList();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminPage/industryIdynamics/list.vue